var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"justify-content-center"},[_c('div',{staticClass:"ticket text-center"},[_c('div',{staticClass:"title"},[_vm._v("Experience how making the most of online data can create value for your organization")])])])}
var staticRenderFns = []

export { render, staticRenderFns }